import { CarConfigurationServiceV1Wrapper } from './v1';
import { CarConfigurationServiceV2Impl } from './v2';
export * from './v1/types';
export * from './v2/types';
const requiredFeatureServices = {
    'locale-service': '^1.0.0',
    'service-config-provider': '^1.0.0'
};
export const defineCarConfigurationService = (options = {}) => ({
    id: 'car-configuration',
    dependencies: {
        featureServices: requiredFeatureServices
    },
    create({ featureServices }) {
        const carConfigurationServiceV2 = new CarConfigurationServiceV2Impl(options, featureServices['locale-service'], featureServices['service-config-provider']);
        const carConfigurationServiceV1 = new CarConfigurationServiceV1Wrapper(carConfigurationServiceV2);
        return {
            '1.0.0': () => ({ featureService: carConfigurationServiceV1 }),
            '2.1.0': () => ({ featureService: carConfigurationServiceV2 })
        };
    }
});
